// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_separator-module__separator--1m11R{padding:0px 4px;font-weight:bold;color:#c6ced5}.decision_separator-module__separator--1m11R:hover{text-decoration:none}\n", ""]);
// Exports
exports.locals = {
	"separator": "decision_separator-module__separator--1m11R"
};
module.exports = exports;
